'use client'
import React from "react";
import { useEffect, useState } from "react";
import { LoginValidation } from "@/validation/loginValidation";
import {
  Formik,
  Form as FormikForm,
  ErrorMessage,
  useFormikContext,
} from "formik";
import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/navigation";
import {
  fetchLoginUser,
  login_state,
} from "@/store/slices/auth/login_slice";
import { getAccessToken } from "@/store/slices/auth/token-login-slice";
import { get_array_from_roledoctype } from '@/services/api/roles/roles-api';
// import { SelectedFilterLangDataFromStore } from "@/store/slices/general_slices/selected-multilanguage-slice";
import getOtpFetchApi from "@/services/api/auth/get-otp-api";
// import useMultilangHook from "@/hooks/LanguageHook/Multilanguages-hook";
import { usePathname } from "next/navigation";
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Checkbox from '@mui/material/Checkbox'

import FormControlLabel from '@mui/material/FormControlLabel'
import Logo from "../layout/shared/Logo";
import { FormHelperText, Typography } from "@mui/material";
import themeConfig from '@configs/themeConfig'
// import type { FormEvent } from 'react'
// // Hook Imports
// import { useImageVariant } from '@core/hooks/useImageVariant'
import { failmsg, hideToast, successmsg } from "@/store/slices/general_slices/toast_notification_slice";
import { showToast } from "../ToastNotificationNew";
import { Button, Box } from "@mui/material";




const loginPage = (multi_lang: any) => {
  const dispatch = useDispatch();
  const loginSucess: any = useSelector(login_state);
  const [newState, setNewState] = useState<any>([]);
  const [loginStatus, setLoginStatus] = useState<any>("");
  const [newValues, setnewValue] = useState<any>("");
  const [ShowAlertMsg, setShowAlertMsg] = useState<boolean>(false);
  const [messageState, setMessageState] = useState<any>("");
  const [isOtpLoginState, setIsOtpLoginState] = useState<boolean>(false);

  const [selectedMultiLangData, setSelectedMultiLangData] = useState<any>();
  const pattern = new RegExp(/^\d{1,10}$/);
  const [mobile, setmobile] = useState("");
  const [isError, setIsError] = useState(false);
  const [isPasswordShown, setIsPasswordShown] = useState(false)
  const [menuList, setMenuList] = useState<any>();
  const [isLoadmenu, setIsLoadmenu] = useState(false)

  const handleClickShowPassword = () => setIsPasswordShown(show => !show)

  useEffect(() => {
    console.log("multi_lang?.multi_lang", multi_lang );
    setSelectedMultiLangData(multi_lang?.multi_lang[0]?.value);


    

    // getcustomerData();
    

  });

  useEffect(() => {
    const getmenuData: any = async () => {
      try {
        let getRecords = await get_array_from_roledoctype();
        console.log("getRecords", getRecords);
        if (getRecords) {
          setMenuList(getRecords);
          setIsLoadmenu(true);
        } else {
          console.log('error');
          // setErr(true);
        }
      } catch (error) {
        console.error("Error fetching menu data", error);
        // setErr(true);
      } finally {
        console.log('finally');
        // setLoading(false);
      }
    };
    if (isLoadmenu == false) {
      getmenuData();  
    }
    
  },[selectedMultiLangData])

  const location = usePathname();
  let isLoggedIn: any;
  let guestLogin: any;
  const router = useRouter();
  let obj = {
    isGoogleLogin: false,
    visitor: false,
    isOtpLogin: false,
  };
  if (typeof window !== "undefined") {
    guestLogin = localStorage.getItem("guest");
    isLoggedIn = localStorage.getItem("isLoggedIn");
  }

 


  const handlesubmit = (values: any,actions:any) => {
    const val = Object.assign(obj, values);

    const user_params = {
      values: values,
      guest: guestLogin,
      isOtpLogin: isOtpLoginState === true ? true : false,
    };
    console.log("userparams", user_params);
    console.log(loginStatus, "loginStatus");

    dispatch(getAccessToken(user_params));
    



    setTimeout(() => {
      const loginStatusFromStorage: any = localStorage.getItem("isLoggedIn");
      if(loginStatusFromStorage===null){
        actions.setSubmitting(false);  
      }
      setLoginStatus(loginStatusFromStorage);
      setIsOtpLoginState(false);
      actions.setSubmitting(false); 
    }, 2000);
  };

  useEffect(() => {

    if (isLoggedIn) {

      if (location == "/login") {
        // window.location.href = "/";
      }

    }
    if (loginStatus === "true") {
      dispatch(successmsg("logged in sucessfully"));
      setTimeout(() => {
        dispatch(hideToast());
      }, 800);
      router.push("/");
      localStorage.removeItem("guest");
      localStorage.removeItem("guestToken");
    }
    else {
      dispatch(failmsg("Invalid Credential"));
      setTimeout(() => {
        dispatch(hideToast());
      }, 800);
    }
  }, [handlesubmit]);

  console.log(loginStatus, "loginStatus");

  console.log(isLoggedIn, "newState");
  const FormObserver: React.FC = () => {
    const { values }: any = useFormikContext();
    useEffect(() => {
      setnewValue(values);

    }, [values]);
    return null;
  };

  const HandleGetOtp = async (e: any) => {
    let newObj = {
      email: newValues?.email,
    };
    e.preventDefault();
    let GetOtpApiRes: any = await getOtpFetchApi(newObj);

    if (GetOtpApiRes?.data?.message?.msg === "success") {
      setShowAlertMsg(true);
      setMessageState(GetOtpApiRes?.data?.message?.msg);
      showToast(GetOtpApiRes?.data?.message?.msg, "success")
      setIsOtpLoginState(true);
      setTimeout(() => {
        setShowAlertMsg(false);
        setMessageState("");
      }, 1000);
    } else {
      setShowAlertMsg(true);
      setMessageState(GetOtpApiRes?.data?.message?.msg);
      showToast(GetOtpApiRes?.data?.message?.error, "error")
      setTimeout(() => {
        setShowAlertMsg(false);
        setMessageState("");
      }, 1500);
    }
  };


  return (    
    
    <>
      <div className="pt-0">

        <Link href='/' className='flex justify-center items-center mbe-6'>
          <Logo from="login" />
        </Link>

        <div className='flex flex-col gap-5'>
          <div>
            <Typography variant='h4'>{(selectedMultiLangData?.login_heading) ? selectedMultiLangData?.login_heading : ` Please login`}</Typography>
            {/* <Typography className='mbs-1' variant='h6'>Please login. </Typography> */}
          </div>
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={LoginValidation}
            onSubmit={(values, actions) => {
              handlesubmit(values,actions);              
              

            }}            
          >
            {({ isSubmitting, handleChange, handleBlur }) => (
              <div className="auth-form-wrapper login-wrapper flex flex-col gap-5">
                <FormikForm>
                  <div className='flex flex-col gap-2'>
                    <TextField autoFocus fullWidth label='Email' onChange={handleChange}
                      onKeyUp={(e) => {
                      }}
                      onBlur={handleBlur}
                      type="text"
                      name="email"
                      placeholder={(selectedMultiLangData?.email_or_mobile) ? selectedMultiLangData?.email_or_mobile : "Email"} />

                    <FormHelperText error><ErrorMessage name="email" /></FormHelperText>

                    {ShowAlertMsg && (
                      <div className="pt-1">
                        {messageState === "success"
                          ? "OTP send sucessfully on registered email"
                          : "Please enter valid registered email"}
                      </div>
                    )}
                    <TextField
                      fullWidth
                      label='Password'
                      id='password'
                      type={isPasswordShown ? 'text' : 'password'}
                      autoComplete="off"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton
                              size='small'
                              edge='end'
                              onClick={handleClickShowPassword}
                              onMouseDown={e => e.preventDefault()}
                            >
                              <i className={isPasswordShown ? 'ri-eye-off-line' : 'ri-eye-line'} />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="password"
                      placeholder={(selectedMultiLangData?.password) ? selectedMultiLangData?.password : "Password"}
                    />
                    <FormHelperText error><ErrorMessage name="password" /></FormHelperText>


                    <div className='flex justify-between items-center gap-x-3 gap-y-1 flex-wrap'>
                      <FormControlLabel control={<Checkbox />} label='Remember me' />
                      {/* <Typography className='text-end' color='primary'>
                        <Link href='/forgot-password' rel="noopener noreferrer">
                          {(selectedMultiLangData?.forgot_password) ? selectedMultiLangData?.forgot_password : "Forgot password"} ?
                        </Link>
                      </Typography> */}
                    </div>
                    <Button fullWidth variant='contained' type='submit' disabled={isSubmitting}>
                      {(selectedMultiLangData?.sign_in) ? selectedMultiLangData?.sign_in : "Sign in"}
                    </Button>
                  </div>

                  <FormObserver />
                </FormikForm>
              </div>
            )}
          </Formik>
        </div>
        <hr></hr>
      </div>
    </>
  );
};

export default loginPage;
